module.exports = __webpack_public_path__ + "img/Inositol.a0d7e2c9.jpg";